<template>
  <v-container fill-height>
    <v-layout justify-center>
      <v-flex>
        <div class="breadcrumbs__wrapper">
          <div>
            <span class="breadcrumbs__title">Gestión de convenios</span>
          </div>
        </div>
        <v-divider class="mt-2"></v-divider>
        <!-- ACtive buttons -->
        <!-- <v-row class="mt-10">
          <v-col class="button__wrapper" cols="6">
            <v-btn
              :class="
                typeSelection === 1
                  ? 'white--text'
                  : 'white--text btn__not__selected'
              "
              @click="typeSelection = 1"
              ><v-icon left> mdi-link-variant</v-icon>Activos</v-btn
            ><v-btn
              :class="
                typeSelection === 2
                  ? 'white--text ml-4'
                  : 'white--text ml-4 btn__not__selected'
              "
              @click="typeSelection = 2"
              ><v-icon left> mdi-link-variant-off</v-icon>Cerrados</v-btn
            ><v-btn
              :class="
                typeSelection === 3
                  ? 'white--text ml-4'
                  : 'white--text ml-4 btn__not__selected'
              "
              @click="typeSelection = 3"
              ><v-icon left> mdi-link-variant-off</v-icon>TODOS</v-btn
            >
          </v-col>
        </v-row> -->

        <ConveniosTable
          v-if="typeSelection === 1"
          class="mt-10"
          :headers="this.headersPR"
          :values="this.getConvenios"
        />
        <ConveniosTable
          v-if="typeSelection === 2"
          class="mt-10"
          :headers="this.headersPR"
          :values="this.getConvenios"
        />
        <ConveniosTable
          v-if="typeSelection === 3"
          class="mt-10"
          :headers="this.headersPR"
          :values="this.getConvenios"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// import Table from "@/components/Table.vue";
import ConveniosTable from "@/components/Convenios/ConveniosTable.vue";
// import ContractsMarcoTable from "@/components/contracts/ContractsMarcoTable.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Convenios",
  components: { ConveniosTable },
  data() {
    return {
      allTypes: [],
      closedType: [],
      activeTypes: [],
      search: "",
      typeSelection: 1,
      headersPR: [
        {
          text: "Nombre de expediente",
          align: "start",
          filterable: false,
          value: "fileName",
          width: "",
        },
        //{ text: "Gestor", value: "promotor", width: "145px" },
        // { text: "Validador", value: "validator", width: "145px" },
        { text: "Ambito", value: "ambito", width: "145px" },
        { text: "Naturaleza", value: "type", width: "145px" },
        {
          text: "Importe",
          value: "amount",
          width: "",
          align: "right",
        },
        {
          text: "Fecha Inicio",
          value: "startingDate",
          align: "center",
          width: "105px",
        },
        {
          text: "Fecha Finalización",
          value: "endingDate",
          align: "center",
          width: "105px",
        },
        // {
        //   text: "Estado",
        //   value: "state",
        //   align: "left",
        //   width: "125px",
        // },
        { text: "Acciones", value: "actions", align: "center" },
      ],
      puntual: [],
      recurrent: [],
      marco: [],
      contractsPR: [],
      items: [
        { title: "Puntual", to: "/cecontractrandp/Puntual" },
        // { title: "Recurrente", to: "/cecontractrandp/Recurrente" },
        { title: "Marco", to: "/cecontractmarco/Marco" },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getObjectById",
      "getConvenios",
      "getUserData",
      "getCCframes",
      "getInvoices",
    ]),
    getItems() {
      if (this.getUserData) {
        if (this.getUserData.role.some((val) => [1, 2].includes(val))) {
          return this.items;
        } else {
          return this.items.filter((item) => item.title !== "Marco");
        }
      } else return [];
    },
    getDafUsers() {
      if (
        this.getUserData &&
        (this.getUserData.sigla === "DAF" ||
          this.getUserData.sigla === "DG" ||
          this.getUserData.sigla === "DG-1")
      )
        return true;
      else return false;
    },
  },
  methods: {
    ...mapActions(["getDBConvenios", "getDBCCframe", "getDBInvoices"]),
  },
};
</script>

<style scoped>
.breadcrumbs__wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.breadcrumbs__title {
  padding: 8px 0;
  border-bottom: 3px solid #008076;
}

.theme--light.v-btn.v-btn--has-bg {
  background: #008076;
}

.btn__not__selected {
  background: #969696 !important;
}
.button__wrapper {
  padding: 0 12px;
}
</style>
